import TreeMapFilterItem from "../tree-map-filter-item";

import { useTreeMapFilterLocation } from "./tree-map-filter-location.hook";

import "./tree-map-filter-location.style.less";

const TreeMapFilterLocation = () => {
  const { filterItems, onToggle } = useTreeMapFilterLocation();

  return (
    <div className="tree-map-filter-location">
      {filterItems.map(({ value, name, checked }) => (
        <TreeMapFilterItem
          key={value}
          title={name}
          checked={checked}
          onToggle={() => onToggle(value, checked)}
        />
      ))}
    </div>
  );
};

export default TreeMapFilterLocation;
